import React from 'react';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-md w-full mx-4 space-y-8 p-6 md:p-8 bg-white rounded-2xl shadow-xl">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 md:w-16 md:h-16 bg-primary-100 rounded-full flex items-center justify-center">
              <i className="fas fa-user-plus text-2xl md:text-3xl text-primary-600"></i>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">SchoolSuite System</h2>
          <p className="mt-2 text-sm md:text-base text-gray-600">Account Registration</p>
        </div>

        {/* Notice: Registration is disabled */}
        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-md text-sm text-yellow-800">
          <div className="flex">
            <div className="flex-shrink-0">
              <i className="fas fa-exclamation-triangle text-yellow-500 mr-2"></i>
            </div>
            <div className="flex-1 space-y-2">
              <p className="font-semibold">Self‑registration is currently disabled.</p>
              <p>
                <strong>Staff members</strong> (Form Masters, Subject Teachers) cannot create accounts here.
                Your School Administrator will onboard you, and you will receive an invitation email with login instructions.
              </p>
              <p>
                <strong>School Administrators:</strong> When you registered your school, your login credentials
                were provided. Please use them to sign in. There is no need to create another account.
              </p>
              <p className="mt-3">
                👉 If you are a new School Administrator,{' '}
                <a href="/school/register" className="font-medium underline hover:text-yellow-700">
                  register your school first
                </a>
                .
              </p>
              <p className="mt-2">
                Already have an account?{' '}
                <button
                  onClick={() => navigate('/login')}
                  className="font-medium text-primary-600 hover:text-primary-500 hover:underline"
                >
                  Sign in here
                </button>
              </p>
            </div>
          </div>
        </div>

        {/* No form fields – registration is blocked */}

        <div className="text-center text-gray-600 pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Powered and hosted by{' '}
            <a
              href="https://cbthost.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 hover:underline font-medium"
            >
              cbthost.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;